<template>
 <base-block>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="User Attended Test List" active
            ><p>
              <base-block>
               <!-- Full Table -->
                <base-block rounded title="Users Attended The Test">
                  <br />
                  <div class="text-right" v-if="users.length > 0">
                    <b-button variant="success" @click="exportsubData()">Export</b-button>
                  </div>
                  <br />
                  <b-table-simple
                    responsive
                    bordered
                    striped
                    table-class="table-vcenter"
                    v-if="users.length > 0"
                  >
                    <b-thead>
                      <b-tr>
                        <b-th class="text-center">S.NO</b-th>
                        <b-th class="text-center">User Name</b-th>
                        <b-th class="text-center">Correct Answers</b-th>
                        <b-th class="text-center">Incorrect Answers</b-th>
                        <b-th class="text-center">Un Attempted</b-th>
                        <b-th class="text-center">Percentage</b-th>
                        <b-th class="text-center">Score</b-th>
                          <b-th class="text-center">Rank</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(user, index) in users" :key="index">
                        <b-td class="text-center">
                          {{ index + 1 }}
                        </b-td>
                        <b-td class="text-center"> {{ user.user != null ? user.user.name : '-' }} </b-td>
                        <b-td class="text-center">
                          {{ user.total_correct_answer }}
                        </b-td>
                        <b-td class="text-center">
                          {{ user.total_incorrect_answer }}
                        </b-td>
                        <b-td class="text-center">
                          {{ user.total_unattempted }}
                        </b-td>
                        <b-td class="text-center">
                          {{ user.pass_percentage }}
                        </b-td>
                        <b-td class="text-center">
                          {{ user.score }}
                        </b-td>
                        <b-td class="text-center">
                          {{ index + 1 }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </base-block>
                <!-- END Full Table -->
              </base-block>
            </p></b-tab
          >

           <b-tab title="User Not-Attended Test List"
            ><p>
              <base-block>
               <!-- Full Table -->
                <base-block rounded title="Users Not-Attended The Test">
                  <br />
                  <div class="text-right" v-if="user_not_attended.length > 0">
                    <b-button variant="success" @click="exportNotAttendedData()">Export</b-button>
                  </div>
                  <br />
                  <b-table-simple
                    responsive
                    bordered
                    striped
                    table-class="table-vcenter"
                    v-if="user_not_attended.length > 0"
                  >
                    <b-thead>
                      <b-tr>
                        <b-th class="text-center">S.NO</b-th>
                        <b-th class="text-center">User Name</b-th>
                        <b-th class="text-center">Email</b-th>
                        <b-th class="text-center">Mobile</b-th>
                        <b-th class="text-center">Register Number</b-th>
                        <b-th class="text-center">Department</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(usern, index) in user_not_attended" :key="index">
                        <b-td class="text-center">
                          {{ index + 1 }}
                        </b-td>
                        <b-td class="text-center"> {{ usern.name }} </b-td>
                        <b-td class="text-center">
                          {{ usern.email }}
                        </b-td>
                        <b-td class="text-center">
                          {{ usern.mobile }}
                        </b-td>
                        <b-td class="text-center">
                          {{ usern.registration_number }}
                        </b-td>
                        <b-td class="text-center">
                          {{ usern.department }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </base-block>
                <!-- END Full Table -->
              </base-block>
            </p></b-tab
          >
          </b-tabs>

  </div>
 </base-block>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      users: [],
      user_not_attended: [],
    };
  },
  mounted() {
    this.getUserAttended();
  },
  methods: {
    async exportsubData() {

      if(this.users[0].test_type == "subscription_mock_test"){
        this.type = "mock_test";
      }else{
        this.type = "practice_test";
      }
     // this.college = "college";
     // alert("fdvgdfbvgf");
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college-sub-userExcel/${this.users[0].subscription_id}/${this.$route.params.testId}/${this.type}
`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          // const url = URL.createObjectURL(
          //   new Blob([response.data], {
          //     type: "application/vnd.ms-excel",
          //   })
          // );
          const link = document.createElement("a");
          link.href = `${response.data.url}/${this.$route.params.collegeAdminId}`;
          console.log("link",link.href);
          link.setAttribute("download", "");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async exportNotAttendedData() {

     
        this.type = "practice_test";
     // this.college = "college";
     // alert("fdvgdfbvgf");
      await axios
        .get(
          `${this.$store.getters.baseUrl}/collegenot-attended-userExcel/${this.$route.params.testId}/${this.type}
`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          // const url = URL.createObjectURL(
          //   new Blob([response.data], {
          //     type: "application/vnd.ms-excel",
          //   })
          // );
          const link = document.createElement("a");
          link.href = `${response.data.url}/${this.$route.params.collegeAdminId}`;
          console.log("link",link.href);
          link.setAttribute("download", "");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getUserAttended(){
      await axios
        .get(
          `${this.$store.getters.baseUrl}/test-attended/${this.$route.params.testId}/${this.$route.params.collegeAdminId}
`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.users = response.data.user_tests;
            this.user_not_attended = response.data.user_not_attended;
           /* if (!this.users.length > 0) {
              this.$swal({
                title: "Info",
                text: "No students have attended the test yet",
                icon: "warning",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.push({name:"College All Test Report" });
                } else {
                  this.$router.push({name:"College All Test Report" });
                }
              });
            }*/
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
